import { Component, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { OKTA_CONFIG } from '@okta/okta-angular';
import type { OktaAuth } from '@okta/okta-auth-js';

//import { LoadingComponent } from '../../utils/loading/loading';
import { MainFooter } from '../main-footer/main-footer';
import { MainHeader } from '../main-header/main-header';

@Component( {
  selector: 'app-main',
  imports: [
    MatCardModule,
    MatIconModule,
    MainFooter,
    MainHeader,    
    RouterOutlet,
    //LoadingComponent,
  ],
  templateUrl: './main.html',
  styleUrl: './main.css'
} )
export class Main 
{
  constructor(
    @Inject( OKTA_CONFIG ) private oktaConfig: { oktaAuth: OktaAuth }
  ){}

  public async signOut(): Promise<void>
  {
    const tokens = await this.oktaConfig.oktaAuth.tokenManager.getTokens();
    const accessToken = tokens.accessToken ? tokens.accessToken : undefined;
    await this.oktaConfig.oktaAuth.signOut( {
      revokeAccessToken: true,
      accessToken,
      postLogoutRedirectUri: window.location.origin + '/login'
    } );
  }

}
